import { ActionCreator } from 'redux';
import { ActionTypes, DisableSpinnerAction, EnableSpinnerAction } from './actions';

export const enableLoadingSpinner: ActionCreator<EnableSpinnerAction> = (nextKey: string) =>
    ({ type: ActionTypes.ENABLE_SPINNER, key: nextKey});

export const disableLoadingSpinner: ActionCreator<DisableSpinnerAction> = (nextKey: string) =>
    ({ type: ActionTypes.DISABLE_SPINNER, key: nextKey });